import { useState, useMemo } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FaChevronDown } from "react-icons/fa";

export default function SearchableDropdown({
  options,
  placeholder = "Select an option",
  onSelect,
  selected,
}){
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const selectedLabel = useMemo(() => {
    return options.find((option) => option.id === selected)?.label || "";
  }, [selected]);

  const filteredOptions = useMemo(() => {
    if (!query) return options;
    return options.filter((option) =>
      option.label.toLowerCase().includes(query.toLowerCase())
    );
  }, [query, options]);

  const handleSelect = (value) => {
    setIsOpen(false);
    setQuery("");
    onSelect?.(value.id);
  };

  return (
    <div className="relative w-64">
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        className="w-full flex justify-between items-center px-4 py-2 border rounded-lg bg-white text-left shadow-sm"
      >
        <span>{selectedLabel || placeholder}</span>
        <FaChevronDown
          className={`w-4 h-4 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            className="absolute mt-1 w-full bg-white border rounded-lg shadow-lg z-10"
          >
            <input
              className="w-full px-4 py-2 border-b outline-none"
              placeholder="Search..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <div className="max-h-48 overflow-y-auto">
              {filteredOptions.length > 0 ? (
                filteredOptions.map((item) => (
                  <div
                    key={item.id}
                    onClick={() => {
                      handleSelect(item);
                    }}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  >
                    {item.label}
                  </div>
                ))
              ) : (
                <div className="px-4 py-2 text-gray-500">No results</div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
